import { useContext } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import Authorize from "./Authorize";
import { ModeAuthorizeEnum } from "../utils/constants";

// eslint-disable-next-line react/prop-types
const ProtectedRoute = ({ children, access, permission }) => {
  const { accessToken } = useAuth();
  if (!accessToken) {
    if (access == 0 || access == 2 || access == 3) {
      return children;
    }
  } else {
    if (access == 0 || access == 1) {
      return (
        <Authorize mode={ModeAuthorizeEnum.access} permission={permission}>
          {children}
        </Authorize>
      );
    }
    return <Navigate to="/dashboard"></Navigate>;
  }
  return <Navigate to="/sign-in"></Navigate>;
};
export default ProtectedRoute;
